import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import styles from './Input.module.scss'

const Input = ({ value, placeholder, type, onChange, className, disabled, onFocus }) => {
  const input = useRef();
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = event => {
    const { value } = event.target;
    onChange(value);
  };

  const handleFocus = (e) => {
    setIsFocused(true);
    if (onFocus) onFocus(e);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const hasValue = value && value.toString().trim().length > 0;
  const showPlaceholder = !hasValue && !isFocused;

  return (
    <div className={classNames(styles.customField)}>
      <input
        type={type}
        ref={input}
        value={value || ''}
        placeholder="&nbsp;"
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        className={styles.input}
      />
      {showPlaceholder && (
        <span onClick={() => input.current.focus()} className={styles.placeholder}>
          {placeholder}
        </span>
      )}
    </div>
  );
};

export default Input;